module.exports = __webpack_public_path__ + "1dc693ff72ad1a59ab414368c4e18af6.svg";